import axios from 'axios';
import store from './../store';
import Permissions from '../mixins/PermissionsHelpers.vue';
import Constants from './../constants';

export default {
  namespaced: true,

  state: {
    msgPremium: '',
    listPages:[
      {name: 'Dashboard', link: '/', icon: 'home', libelle: 'Accueil', permission_name_read: Constants.PERMISSION_DASHBOARD_PAGE, premium: false},
    ],

    isFullMenu: true,
  },

  getters: {
    msgPremium(state){
      return state.msgPremium;
    },
        
    listPages(state){
      return state.listPages;
    },

    isFullMenu(state){
      return state.isFullMenu;
    }
  },

  mutations: {
    SET_LISTPAGES(state, pages){
      state.listPages = pages;
    },

    SET_ISFULLMENU(state, bool){
      state.isFullMenu = bool;
    },

    SET_MSGPREMIUM(state, msg){
      state.msgPremium = msg;
    }
  },

  actions: {
    async sort_page_list(context){
      let sorted = [];

      Constants.MENU_LIST_SORT_ORDER.forEach(name => {
        context.getters.listPages.forEach(page => {
          if (page.name === name) {
            sorted.push(page);
          }
        });
      });
      context.commit('SET_LISTPAGES', sorted);
    },
  

    async sort_by_permissions(context) {
      console.log('wait...sort_by_permissions');

      let listPages = [];
      let notAllowed = [];

      context.getters.listPages.forEach(page => {
        if(Permissions.methods.$subscribed() || Permissions.methods.$freeParticulier()){
          listPages.push(page);
        }else{
          notAllowed.push(page);
        }
      });

      context.commit('SET_LISTPAGES', listPages.concat(notAllowed));
    },

    async isFullMenu_by_path (context, url) {
      console.log('wait...FullMenu_by_path');
      let full = url === '/'
                || url.includes('not-allowed')
                || url.includes('upgrade')
                || url.includes('fiches-de-poste')
                || url.includes('ref-formation')
                || url.includes('permissions')
                || (url.includes('neopass') && !url.includes('form'))
                || url === '/preconisations'
                || url.includes('parametres-de-compte')
                || url.includes('abonnement')
                || url.includes('aide')
                || url.includes('documents') && !url.includes('form')
                || url.includes('curriculumvitae') && !url.includes('form')
                || url.includes('recherchecompetences');

      context.commit('SET_ISFULLMENU', full);
    },

    async load_menus(context, url){
      console.log('wait...load_menus');

      await axios.get('/api/module/getModulesMenu').then((response) => {
        //Redirect "modeles de page" link on the good item 
        let menu = response.data.map((mod) => {
          if (mod.link === 'modeles-de-page') {
            mod.name = Constants.TEMPLATE_DEFAULT.name;
            mod.params = {module: Constants.TEMPLATE_DEFAULT.module, page: Constants.TEMPLATE_DEFAULT.page, id_template: 'default'};
          }
          return mod;
        });

        if(store.getters['auth/role'] == Constants.ROLE_BENEFICIAIRE || Permissions.methods.$freeParticulier()){
          if(Permissions.methods.$can(Constants.PERMISSION_NEOPASS_FORM_PAGE)){
            menu.push(
              {name: Constants.PERMISSION_NEOPASS_FORM_PAGE, link: '/form/neopass/'+store.getters['auth/user'].id, icon: 'layers', libelle: 'Carnet de parcours', permission_name_read: Constants.PERMISSION_NEOPASS_FORM_PAGE, premium: true, params:{id:store.getters['auth/user'].id}},
            );
          }
          if(Permissions.methods.$can(Constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_PAGE)){
            menu.push(
              {name: 'Cartoindcompperso', link: 'cartographies/individuelles/'+store.getters['auth/user'].id+'/competencesperso', icon: 'bar-chart-2', libelle: 'Cartographies', permission_name_read: Constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_PAGE, premium: true, params:{id:store.getters['auth/user'].id}},
            );
          }
        }
        context.commit('SET_LISTPAGES', menu);
      }).catch(error => console.log('ERRRR:', error));
            
      if(store.getters['auth/role'] === Constants.ROLE_SUPER_ADMIN){
        return;
      }

      await context.dispatch('sort_page_list');
      await context.dispatch('sort_by_permissions');
      await context.dispatch('isFullMenu_by_path', url);
    }
  }
};
